import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";


export const CITIZEN_UPADATE_POPULAR_SERVICE = gql`
    mutation CitizenUpdatePopularServiceMutation($serviceUniqueId: String) {
        citizenUpdatePopularServiceMutation(serviceUniqueId: $serviceUniqueId) {
            response {
                ${baseResponse}
            }
        }
    }
`;
